import RequestManager from "src/requests/RequestManager";
import { Team, Player } from "../interfaces";
import { isMockDataActive, roster, team as mockTeam} from "../mockData";
import { RosterTask, TeamTask } from "../tasks";
import { parsePlayer, parseTeam } from "../utils";

// Se usa en VCardEquipo
export default async function getTeam(teamId: string): Promise<{
    team: Team,
    players: Player[],
    coach?: Player,
    // captain?: Player
}> { 
    const teamTask = new TeamTask(teamId);
    let team;
    let rosterResult;
    const rosterTask = new RosterTask(teamId);
    if(isMockDataActive) {
        rosterResult = roster;
        team = mockTeam;
    } else {
        const teamResult = await RequestManager.addRequest(teamTask);
        rosterResult = await RequestManager.addRequest(rosterTask);
        team = parseTeam(teamResult.team || {});
    }
    const players = (rosterResult.players && rosterResult.players.map((player: any) => parsePlayer(player))) || [];
    const coach = parsePlayer((rosterResult.coaches && rosterResult.coaches.length > 0 && rosterResult.coaches[0]) || {});
    // const captain = players.find((player: Player) => player.role === "CAPTAIN");

    return {
        team,
        players,
        coach,
        // captain
    }
}


// WEBPACK FOOTER //
// ./src/mundial/requests/api/getTeam.ts